"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
exports.theme = {
    menuButtonItem: {
        shared: 'flex px-4 py-3 font-medium text-sm hover:bg-misc-50 transition text-start',
        types: {
            default: 'text-primary-500',
            danger: 'text-danger-500',
        },
        states: {
            active: {
                layer: 'bg-misc-300',
            },
        },
    },
    menuButton: {
        container: {
            layer: 'flex-shrink-0 relative inline-block text-start',
        },
    },
};
//# sourceMappingURL=themes.js.map